import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Modal, Button } from "react-bootstrap";

import Config from "../../_config/config";
import { ReactComponent as LoadingIcon } from "../../_assets/imgs/loading.svg";
import ApiService from "../../_services/ApiService";

import "./my-program.styles.css";

const MyPrograms = () => {
  const history = useHistory();
  const [enrolledModules, setEnrolledModules] = useState([]);
  const [deferredModules, setDeferredModules] = useState([]);
  const [programName, setProgramName] = useState("");
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showNewModuleModal, setShowNewModuleModal] = useState(false);
  const [ticketData, setTicketData] = useState([]);
  const [ticketRaisedData, setTicketRaisedData] = useState({});
  const [showModuleDate, setShowModuleDate] = useState(false);
  const [enrollmentId, setEnrollmentId] = useState(null);
  const [showButtonLoading, setShowButtonLoading] = useState(false);
  const [ticketDocument1, setTicketDocument1] = useState(null);
  const [ticketDocument2, setTicketDocument2] = useState(null);
  const [moduleDisplayName, setModuleDisplayName] = useState("");

  const fetchProgramDetails = async () => {
    try {
      const response = await ApiService.fetchProgramDetails();
      const enrollmentId = response.data.enrollmentId;
      const enrolledModulesDetails = response.data.registeredModules;
      const deferredModulesDetails = response.data.deferredModules;
      const programNameDetail = response.data.programName;
      const showModuleDateDetail = response.data.showModuleDates;
      const moduleNameDetail = response.data.moduleDisplayName;

      setModuleDisplayName(moduleNameDetail);
      setShowModuleDate(showModuleDateDetail);
      setProgramName(programNameDetail);
      setEnrolledModules(enrolledModulesDetails);
      setDeferredModules(deferredModulesDetails);

      setEnrollmentId(enrollmentId);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProgramDetails();
  }, []);

  const openChangeModal = () => {
    setShowChangeModal(true);
  };
  const closeChangeModal = () => {
    setShowChangeModal(false);
  };
  const openNewModuleModal = () => {
    setShowNewModuleModal(true);
  };
  const closeNewModuleModal = () => {
    setShowNewModuleModal(false);
  };

  const handleChangeRequest = async (courseId) => {
    const typesDetails = await ApiService.getStudentTicketTypes();
    console.log(typesDetails);
    setTicketData(typesDetails.data.ticketTypes);
    setTicketRaisedData({
      courseId,
    });
    openChangeModal();
  };

  const onUploadDocument = (e) => {
    const { name } = e.target;
    if(name === "document1") setTicketDocument1(e.target.files[0]);
    if(name === "document2") setTicketDocument2(e.target.files[0]);
  };

  const handleNewModuleRequest = async (termId) => {
    setTicketRaisedData({
      typeId: 4,
      termId,
    });
    openNewModuleModal();
  };

  const handleFormChanges = (e) => {
    const { name, value } = e.target;
    console.log(name, value);

    setTicketRaisedData({
      ...ticketRaisedData,
      [name]: value,
    });
  };

  const hideChangeRequest = (ticketRaisedData) => {
    const enrolledModulesData = [...enrolledModules];

    enrolledModulesData.forEach((term) => {
      term.modules.forEach((module) => {
        if (module.moduleId === ticketRaisedData.courseId) {
          module.ticketDetails = {};
        }
      });
    });

    setEnrolledModules(enrolledModulesData);
  };

  const showSuccessMessage = ()=>{
    swal({
      text:"Thank you, Your request has been saved and we will revert soon on this.",
      icon: "success",
      button: "Ok",
    }).then(() => {})
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setShowButtonLoading(true);

    const formData = new FormData();
    if(
      ticketDocument1
    ){
      formData.append("ticketDocument1", ticketDocument1, ticketDocument1?.name);
    }
    if(
      ticketDocument2
    ){
      formData.append("ticketDocument2", ticketDocument2, ticketDocument2?.name);
    }
    
    formData.append(
      "ticketRaisedData",
      JSON.stringify({ ...ticketRaisedData, enrollmentId })
    );
    
    
    try {
      const data = await ApiService.sendStudentTicketDetails(formData);
      console.log(data);
      hideChangeRequest(ticketRaisedData);
      closeChangeModal();
      showSuccessMessage();
      closeNewModuleModal();
      setTicketRaisedData({});
    } catch (error) {
      console.log(error);
    } finally {
      setShowButtonLoading(false);
    }
  };

  let user = JSON.parse(localStorage.getItem("user")) || [];
  var tenant = localStorage.getItem("tenant") || Config.siteTitle;
  let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
  var url =
    Config.siteUrl +
    tenant +
    "/studentportal/studentPortal.do?reqCode=loadRestMyPrograms&token=" +
    user.token;

  return (
    <div className="program-container">
      {
        <Container fluid>
          <div
            className={`module-header-step2 ${
              portlet.class ? portlet.class : "orange-card"
            }`}
          >
            <div className="">
              <div className="back">
                <FontAwesomeIcon icon={faArrowLeft} onClick={history.goBack} />
              </div>
              <h4>{programName ? programName : "My Programs"}</h4>
            </div>
          </div>
          {Config.siteTitle !== "psb" && Config.siteTitle !== "psb2" ? (
            <iframe
              className="my-program-iframe"
              width="100%"
              title="My Programs"
              src={url}
            ></iframe>
          ) : (
            <div>
              <div className="program-details-wrapper">
                <div className="program-course-name">{/* {programName} */}</div>
                {enrolledModules.map((term, j) => (
                  <div key={j} className="term-details-wrapper">
                    <div className="program-term-name-container">
                      <div className="">
                        <span className="program-term-name">
                          {term.termName}
                        </span>
                      </div>
                    </div>
                    <div className="term-details-wrapper">
                      <div className="course-grid bottom-border subject-heading-container">
                        <span className="program-course-code">{moduleDisplayName} Code</span>
                        <span className="program-course-code">{moduleDisplayName} Name</span>
                        {showModuleDate ? (
                          <span className="program-course-code center-span">
                            Date
                          </span>
                        ) : null}
                        <span></span>
                      </div>
                      {term.modules?.map((module, i) => (
                        <div
                          key={`${j}-${i}`}
                          className={`course-grid ${
                            i === term.modules.length - 1
                              ? "round-bottom-border"
                              : "bottom-border"
                          } ${i % 2 !== 0 ? "alternative-row-color" : ""}`}
                        >
                          <span className="program-course-code">
                            {module.moduleCode}
                          </span>
                          <span className="program-course-code">
                            {module.moduleName}
                          </span>
                          {showModuleDate ? (
                            <span className="program-course-code center-span">
                              <span className="bold-text margin-2px">
                                {module.startDate || "--"}
                              </span>
                              <span className="italic-text margin-2px">
                                {module.startDate || module.endDate ? "to" : ""}
                              </span>
                              <span className="bold-text margin-2px">
                                {module.endDate || "--"}
                              </span>
                            </span>
                          ) : null}
                          <span className="center-span">
                            {module.ticketDetails ? null : (
                              <span
                                className="btn btn-outline-danger change-request-span"
                                onClick={() =>
                                  handleChangeRequest(module.moduleId)
                                }
                              >
                                <i className="ph ph-swap chage-request-icon-font"></i>
                                Request change
                              </span>
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              {deferredModules.length ? (
                <div className="program-details-wrapper">
                  <div className="term-details-wrapper">
                    <div className="program-term-name-container">
                      <div className="">
                        <span className="program-term-name">
                          Deferred Modules
                        </span>
                      </div>
                    </div>
                    <div className="term-details-wrapper">
                      <div className="course-grid bottom-border subject-heading-container">
                        <span className="program-course-code">{moduleDisplayName} Code</span>
                        <span className="program-course-code">{moduleDisplayName} Name</span>
                        <span className="program-course-code">Term</span>
                        <span className="program-course-code">Year</span>
                        {showModuleDate ? (
                          <span className="center-span">Approval Date</span>
                        ) : null}
                      </div>
                      {deferredModules?.map((module, i) => (
                        <div
                          key={i}
                          className={`course-grid ${
                            i === deferredModules?.length - 1
                              ? "round-bottom-border"
                              : "bottom-border"
                          } ${i % 2 !== 0 ? "alternative-row-color" : ""}`}
                        >
                          <span className="program-course-code">
                            {module.moduleCode}
                          </span>
                          <span className="program-course-code">
                            {module.moduleName}
                          </span>
                          {/* <span className="program-course-code">
                            <span className="badge text-light bg-primary margin-2px">
                              {module.yearName}
                            </span>
                            <span className="badge text-light bg-success margin-2px">
                              {module.termName}
                            </span>
                            <span className="badge text-light bg-danger margin-2px">
                              {programName}
                            </span>
                          </span> */}
                          <span className="program-course-code">
                            {module.termName}
                          </span>
                          <span className="program-course-code">
                            {module.yearName}
                          </span>
                          <span className="program-course-code center-span">
                            <span className="bold-text margin-2px">
                              {module.approvalDate || "--"}
                            </span>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}

          <Modal size="lg" show={showChangeModal} onHide={closeChangeModal}>
            <form onSubmit={handleFormSubmit}>
              <Modal.Header className="text-uppercase" closeButton>
                {/* <Modal.Title>{dialog.title}</Modal.Title> */}
              </Modal.Header>
              <Modal.Body>
                <div className="form-floating mb-3">
                  <select
                    defaultValue=""
                    className="form-select program-change-border-radius"
                    id="typeofpass"
                    name="typeId"
                    placeholder="Type of Pass"
                    required
                    onChange={handleFormChanges}
                  >
                    <option disabled value="">
                      {" "}
                      -- select an option --{" "}
                    </option>
                    {ticketData.map((ticket, i) => (
                      <option key={i} value={ticket.id}>
                        {ticket.name}
                      </option>
                    ))}
                  </select>

                  <label className="control-label show-tooltip program-change-select-label">
                    What Modification would are you requesting for this Module?
                    <span>*</span>
                  </label>
                </div>
                <textarea
                  className="program-text-area mb-3"
                  name="remarks"
                  rows="5"
                  required
                  onChange={handleFormChanges}
                  placeholder="Please provide more details like the new Module that you want to opt or the new intake that you would ideally request for....."
                ></textarea>
                <div class="input-group mb-3">
                  <label class="input-group-text" for="inputGroupFile01">
                    Upload supporting document 1
                  </label>
                  <input
                    name="document1"
                    onChange={onUploadDocument}
                    type="file"
                    class="form-control"
                    id="inputGroupFile04"
                    aria-describedby="inputGroupFileAddon04"
                    aria-label="Upload"
                    accept="image/*"
                  />
                </div>
                <div class="input-group mb-3">
                  <label class="input-group-text" for="inputGroupFile01">
                  Upload supporting document 2
                  </label>
                  <input
                    name="document2"
                    onChange={onUploadDocument}
                    type="file"
                    class="form-control"
                    id="inputGroupFile04"
                    aria-describedby="inputGroupFileAddon04"
                    aria-label="Upload"
                    accept="image/*"
                  />
                </div>
                <div>
                  <span className="program-bold">*Disclaimer:</span>
                  <ol>
                    <li>
                      Re-module : I understand the pricing rules/requirement and
                      agreed to obeyed by that.
                    </li>
                    <li>
                      I understand the refund policy and as reflect by{" "}
                      <span
                        className="test-details-logout"
                        onClick={() =>
                          window.open(
                            " https://www.psb-academy.edu.sg/student-resources/student-policies/transfer-withdrawal-refund-deferment/."
                          )
                        }
                      >
                        https://www.psb-academy.edu.sg/student-resources/student-policies/transfer-withdrawal-refund-deferment/.
                      </span>
                    </li>
                    <li>
                      I understand the request will be evaluated by PSB Academy
                      and is subject to further approval by PSB Academy.
                    </li>
                  </ol>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  variant="primary"
                  className="text-uppercase"
                  disabled={showButtonLoading}
                >
                  {showButtonLoading ? (
                    <LoadingIcon className="program-loading-icon" />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
          <Modal
            show={showNewModuleModal}
            onHide={closeNewModuleModal}
            size="lg"
          >
            <form onSubmit={handleFormSubmit}>
              <Modal.Header
                className="text-uppercase"
                closeButton
              ></Modal.Header>
              <Modal.Body>
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="program-change-border-radius form-control"
                    placeholder="Identification Document's Number"
                    name="newCourse"
                    onChange={handleFormChanges}
                  />
                  <label className="control-label">
                    Which Module would you consider adding to this term?*
                  </label>
                </div>
                <textarea
                  className="program-text-area"
                  name="remarks"
                  rows="5"
                  required
                  onChange={handleFormChanges}
                  placeholder="Any additional details like your preferred module date etc can be written down in this box"
                ></textarea>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  variant="primary"
                  className="text-uppercase"
                  disabled={showButtonLoading}
                >
                  {showButtonLoading ? (
                    <LoadingIcon className="program-loading-icon" />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </Container>
      }
    </div>
  );
};

export default MyPrograms;
